import template from './checkin.html';
import controller from './checkin.controller';
import './checkin.scss';

let checkinComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller
};

export default checkinComponent;



// WEBPACK FOOTER //
// ./client/app/components/checkin/checkin.component.js